import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import Select from 'react-select';
import lang from '../../constants/Languages.js';

const AdvancedSearchSelect = ({ id, name, setActiveTab, clang, advSearchOptions, defaultValue }) => {
    return (
        <div className="advanced-search__select">
            <label className="advanced-search__select-label">
                {lang[clang].advanced_search.key}
            </label>
            <Select
                onChange={setActiveTab}
                name={name}
                value={defaultValue}
                className="advanced-search__select-field"
                clearable={false}
                deleteRemoves={false}
                backspaceRemoves={false}
                searchable={false}
                options={advSearchOptions}/>
        </div>
    );
};

AdvancedSearchSelect.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(AdvancedSearchSelect);



// WEBPACK FOOTER //
// ./src/components/advanced-search/AdvancedSearchSelect.js